import { Card } from "@/components/ui/card";
import { Link2, Music, ExternalLink } from "lucide-react";

interface CaptainRocaLinksProps {
  t: (en: string, fr: string, es?: string) => string;
}

const links = [
  {
    href: "https://linktr.ee/captainroca",
    icon: Link2,
    titleEn: "Captain ROCA — Linktree",
    titleFr: "Captain ROCA — Linktree",
    titleEs: "Captain ROCA — Linktree",
    descEn: "All official links: socials, projects, ocean missions.",
    descFr: "Tous les liens officiels : réseaux, projets, missions océan.",
    descEs: "Todos los enlaces oficiales: redes, proyectos, misiones oceánicas.",
    accent: "text-accent",
    border: "border-accent/30 hover:border-accent/60",
  },
  {
    href: "https://linktr.ee/Wolfjukebox",
    icon: Music,
    titleEn: "Wolf Jukebox — Captain's Playlist",
    titleFr: "Wolf Jukebox — La Playlist du Capitaine",
    titleEs: "Wolf Jukebox — Playlist del Capitán",
    descEn: "The music Captain ROCA listens to while sailing & coding.",
    descFr: "La musique que Captain ROCA écoute en naviguant & en codant.",
    descEs: "La música que Captain ROCA escucha navegando y programando.",
    accent: "text-neon-purple",
    border: "border-neon-purple/30 hover:border-neon-purple/60",
  },
];

export const CaptainRocaLinks = ({ t }: CaptainRocaLinksProps) => {
  return (
    <section className="py-20 bg-gradient-to-br from-background via-card/20 to-background">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-orbitron font-bold mb-3 text-foreground">
            {t("Follow Captain ROCA", "Suivez Captain ROCA", "Sigue a Captain ROCA")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t(
              "Two official links to stay connected — projects, music, and the journey at sea.",
              "Deux liens officiels pour rester connecté — projets, musique et aventure en mer.",
              "Dos enlaces oficiales para mantenerse conectado — proyectos, música y aventura en el mar."
            )}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline group"
            >
              <Card className={`glass-card p-6 h-full transition-all duration-300 border ${link.border} hover:shadow-lg`}>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-card flex items-center justify-center flex-shrink-0">
                    <link.icon className={`w-6 h-6 ${link.accent}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <h3 className="font-orbitron font-bold text-foreground text-lg leading-tight">
                        {t(link.titleEn, link.titleFr, link.titleEs)}
                      </h3>
                      <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-accent transition-colors flex-shrink-0" />
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {t(link.descEn, link.descFr, link.descEs)}
                    </p>
                    <p className={`text-xs mt-3 font-mono ${link.accent} truncate`}>
                      {link.href.replace("https://", "")}
                    </p>
                  </div>
                </div>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
